var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"subtitle-2",staticStyle:{"height":"100%"},attrs:{"justify":"center","align":"center"}},[_c('span',{staticClass:"caption font-weight-bold"},[_vm._v(_vm._s(_vm.formatedTotal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }